import axios from 'axios'
import { geoRev, geoRevs } from '../../utils'

export default {
  actions: {
    async search ({ commit }, query) {
      const { data } = await axios.post('/api/search', {
        ...query,
        area: geoRev(query.area)
      })

      geoRev(query.area)
      commit('setTotalCount', data.totalCount)
      commit('setResults', {
        append: query.page > 0,
        data: data.paginatedResults
      })
    }
  },
  mutations: {
    setResults (state, results) {
      const { append, data } = results
      if (!append) {
        state.results = geoRevs(data)
      } else {
        state.results = [...state.results, ...geoRevs(data)]
      }
    },
    setTotalCount (state, value) {
      state.totalCount = value
    }
  },
  state: {
    results: [],
    totalCount: 0
  },
  getters: {
    results: state => state.results,
    totalCount: state => state.totalCount
  }
}
